export default [
	{
		path: 'family',
		component: () => import('pages/family/index'),
		name: 'family',
	},
];
